import {CONFIG} from "../../config";
import axios from "axios";

async function InitializeConfigDownloadQuery(deviceId, coreId) {
    const location = CONFIG.API_URL + "device_configuration/download/" + deviceId + "/" + coreId;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };
    try {
        return await axios.post(location, {}, settings);
    } catch (e) {
        return e;
    }
}

export default InitializeConfigDownloadQuery;